import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { getVisibilitySelector, makeAnimationOptionsSelector, TargetSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import classNames from "classnames";
import * as React from "react";
import Component, { type ItemContainerComponentProps } from "../component";
import { makeStyleSelector } from "../selectors";

export type ContainerProps = EntityRef & {
  className?: string;
  children: any;
  style?: React.CSSProperties;
  tag?: string;
  viewonly?: boolean;
};
const makeMapStateToProps = () => {
  const animationOptionsSelector = makeAnimationOptionsSelector(TargetSelector.Entity);
  const visibliltySelector = getVisibilitySelector(TargetSelector.Entity);
  const styleSelector = makeStyleSelector(TargetSelector.Entity);

  return (state: AppState, props: ContainerProps): ItemContainerComponentProps & WithIsVisibleHOCProps => {
    const visibility = visibliltySelector(state, props);
    return {
      ...props,
      animationOptions: animationOptionsSelector(state, props),
      className: classNames(props.className, {
        faded: !visibility && state.isEditMode
      }),
      isVisible: visibility.isVisible,
      style: styleSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
